export const getOrientation = (width: number, height: number): string => {
  if (width === 0 || height === 0) return '1/1'; // Avoid division by zero

  const isSquare = width === height;
  if (isSquare) return 'square';
  else if (width > height) return 'landscape'; // Landscape
  else return 'portrait'; // Portrait
}
